"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _iconsReact = require("../../../../icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CallReason = function CallReason(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    type = _ref.type,
    reasons = _ref.reasons,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    onEditToggle = _ref.onEditToggle,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/_react["default"].createElement(StyledCallReason, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledType, null, type, !readOnly && /*#__PURE__*/_react["default"].createElement(StyledEditButton, {
    onClick: onEditToggle
  }, /*#__PURE__*/_react["default"].createElement(StyledEditIcon, null))), /*#__PURE__*/_react["default"].createElement(StyledList, null, reasons.map(function (_ref2) {
    var value = _ref2.value,
      title = _ref2.title;
    return /*#__PURE__*/_react["default"].createElement(StyledItem, {
      key: value
    }, title, !readOnly && /*#__PURE__*/_react["default"].createElement(StyledDeleteButton, {
      onClick: function onClick() {
        return onDelete({
          value: value
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(StyledDeleteIcon, null)));
  })));
};
var StyledCallReason = _styledComponents["default"].div.withConfig({
  displayName: "CallReason__StyledCallReason",
  componentId: "sc-fx454n-0"
})(["color:#4d4d4d;font-size:14px;"]);
var StyledType = _styledComponents["default"].b.withConfig({
  displayName: "CallReason__StyledType",
  componentId: "sc-fx454n-1"
})(["display:flex;line-height:18px;"]);
var StyledList = _styledComponents["default"].ul.withConfig({
  displayName: "CallReason__StyledList",
  componentId: "sc-fx454n-2"
})([""]);
var StyledItem = _styledComponents["default"].li.withConfig({
  displayName: "CallReason__StyledItem",
  componentId: "sc-fx454n-3"
})(["display:flex;padding-left:10px;position:relative;align-items:center;justify-content:flex-start;&:before{top:8px;left:0;width:3px;height:3px;content:'';position:absolute;border-radius:100%;background-color:#4d4d4d;}"]);
var StyledEditButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CallReason__StyledEditButton",
  componentId: "sc-fx454n-4"
})(["width:15px;height:15px;margin-top:3px;margin-left:6px;border:none;background:none;padding:0;margin:3px 5px 0;&:hover svg path{fill:#007aff;}"]);
var StyledDeleteButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CallReason__StyledDeleteButton",
  componentId: "sc-fx454n-5"
})(["width:12px;height:12px;border:none;background:none;padding:0;overflow:visible;margin:3px 0px 0 5px;svg path{stroke:#979797;}&:hover svg path{stroke:#007aff;}"]);
var StyledEditIcon = (0, _styledComponents["default"])(_iconsReact.EditField).withConfig({
  displayName: "CallReason__StyledEditIcon",
  componentId: "sc-fx454n-6"
})(["width:16px;height:15px;"]);
var StyledDeleteIcon = (0, _styledComponents["default"])(_iconsReact.FieldClose).withConfig({
  displayName: "CallReason__StyledDeleteIcon",
  componentId: "sc-fx454n-7"
})(["width:12px;height:12px;"]);
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CallReason);